import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-procedure-diagram-dialog',
  templateUrl: './procedure-diagram-dialog.component.html',
  styleUrls: ['./procedure-diagram-dialog.component.scss'],
  providers: [DialogService],
})
export class ProcedureDiagramDialogComponent implements OnInit {
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };
  images: any[] = [];
  currentImage: any = {};
  title: string = '';

  constructor(private dialogConfig: DynamicDialogConfig, private dialogRef: DynamicDialogRef) {}

  ngOnInit() {
    const { title, images, currentImage } = this.dialogConfig.data;

    this.title = title;
    this.images = images;

    if (currentImage) {
      this.currentImage = currentImage;
    } else if (this.images && this.images.length) {
      this.currentImage = this.images[0];
    }
  }

  handleClose() {
    this.dialogRef.close({});
  }

  handleSelectImage(image: any) {
    this.currentImage = image;
  }
}
